import { atom } from 'jotai'

export const audioAtom = atom(null)